// Website related settings
const settings = {
  isSplash: false,
};

//SEO Related settings
const seo = {
  title: "Sanjeev Kumar Khatri | Software Engineer & ML Engineer",
  description:
    "Software Engineer and Machine Learning Engineer with 3+ years of experience building production software, machine learning pipelines, AI-enabled applications, and intelligent security systems.",
  og: {
    title: "Sanjeev Kumar Khatri Portfolio",
  },
};

//Home Page
const greeting = {
  title: "Sanjeev Kumar Khatri",
  logo_name: "Sanjeev kumar Khatri",
  nickname: "Kshetri/Meliza",
  subTitle:
    "Software Engineer and Machine Learning Engineer with 3+ years of experience building production software, ML pipelines, AI-enabled applications, and intelligent security systems.",
  resumeLink: `${process.env.PUBLIC_URL}/resume.pdf`,
  githubProfile: "https://github.com/darkamgel",

};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/darkamgel",
  // linkedin: "https://www.linkedin.com/in/sandeep-kshetri-05bbb6183/",
  // gmail: "Sandeepkshetri3@gmail,com",

  // facebook: "https://www.facebook.com/suraj.khatri.9469/",

  // instagram: "https://www.instagram.com/i_am_rogue_sandeep/"

  {
    name: "Github",
    link: "https://github.com/darkamgel",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sanjeevkkhatri/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:sanjeevkumarkhatri6@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Twitter",
  //   link: "",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  {
    name: "Facebook",
    link: "https://www.facebook.com/suraj.khatri.9469/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/i_am_rogue_d_sanjeev/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Software Engineering",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building production backend services and REST APIs with Express.js, Django, and Apex on Salesforce",
        "⚡ Developing frontend applications with React, TypeScript, and Lightning Web Components",
        "⚡ CI/CD, unit testing, and version control with Jenkins, Git, and Jira across production release cycles",
      ],
      softwareSkills: [
        {
          skillName: "React",
          fontAwesomeClassname: "logos-react",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "logos-typescript-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos-javascript",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { backgroundColor: "transparent", color: "#3776AB" },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "logos-django-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Salesforce",
          fontAwesomeClassname: "logos-salesforce",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "Machine Learning and AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building and evaluating CNN, transfer-learning, and multimodal ML pipelines with PyTorch, TensorFlow, and scikit-learn",
        "⚡ Feature engineering, model evaluation, and reproducible end-to-end pipelines on GPU-enabled SLURM clusters",
        "⚡ LLM-assisted application development and NLP",
      ],
      softwareSkills: [
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "scikit-learn",
          fontAwesomeClassname: "logos-scikit-learn",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos-pandas-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
    {
      title: "Security and Cloud",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ AI-assisted vulnerability detection and remediation with CodeQL, OpenGrep, and LLM-assisted exploitability analysis",
        "⚡ Cloud and HPC development workflows, CI/CD pipelines, and containerized deployments",
      ],
      softwareSkills: [
        {
          skillName: "Git",
          fontAwesomeClassname: "logos-git-icon",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos-jenkins",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "logos-mysql",
          style: { backgroundColor: "transparent" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/sandeepkshetri3",
    // },

    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/sanjeevkumarkhatri",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dakota State University",
      subtitle: "M.S. in Computer Science",
      logo_path: "dsu_logo.svg",
      alt_name: "DSU",
      duration: "2025 - Present",
      descriptions: [
        "⚡ Pursuing a Master's in Computer Science focused on machine learning, AI systems, and applied security research.",
        "⚡ Conducting research spanning multimodal machine learning, post-quantum cryptography for IoT, and AI-assisted vulnerability remediation.",
      ],
      website_link: "https://dsu.edu",
    },
    {
      title: "Kathmandu University",
      subtitle: "B.Sc. in Computer Science",
      logo_path: "KUl.svg.png",
      alt_name: "KU",
      duration: "2018 - 2023",
      descriptions: [
        "⚡ I have studied basic software engineering subjects (Probability and statistics , Data Structure and Algorithms , Object Oriented Programming , System Analysis and Design , Machine Learning , Software Engineering",
        "⚡ Apart from this, I have done courses on Data Analytics, Deep Learning, Data Science and Salesforce(Trailhead)",
      ],
      website_link: "https://ku.edu.np",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Google Data Analytics",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/professional-cert/LRQNBQBKALQ4",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/YYGK786URDVX",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },

    {
      title: "Python",
      subtitle: "- Paul Resnick,Steve Oney ,Jaclyn Cohen",
      logo_path: "python.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/NLGDU4DFB2XC",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Python for Data Science & Machine Learning ",
      subtitle: "- Juan E. Galvan ,Ahmed Wael",
      logo_path: "python.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-bc9ab6e7-8c9d-4646-8407-1db1d994e669/",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    // {
    //   title: "Flutter and Dart",
    //   subtitle: "- Snehal Singh",
    //   logo_path: "flutter.png",
    //   certificate_link:
    //     "https://www.udemy.com/certificate/UC-38652a1d-7742-4714-a114-69b4165c41e4/",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    {
      title: "Git and GitHub.",
      subtitle: "- Bogdan Stashchuk",
      logo_path: "github.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Research and Volunteership",
  description:
    "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "AI Security Researcher",
          company: "AI Sweden",
          logo_path: "aisweden_logo.png",
          duration: "May 2026 - July 2026",
          location: "Gothenburg, Sweden and Madison, SD",
          description:
            "Co-developed a hybrid AI vulnerability-remediation pipeline integrating OpenGrep, CodeQL, LLM-assisted detection, exploitability analysis, and automated patch generation across 28 Python codebases with 84 planted vulnerabilities. Achieved a 54.8% end-to-end resolution rate, resolving 46 of 84 planted vulnerabilities, while an LLM-assisted exploitability workflow correctly classified 86 of 99 security findings through confidence scoring, automated validation, and human review.",
          color: "#0879bf",
        },
        {
          title: "Research Assistant — Multimodal Machine Learning",
          company: "Dakota State University",
          company_url: "https://dsu.edu",
          logo_path: "dsu_logo.svg",
          duration: "November 2025 - May 2026",
          location: "Madison, SD",
          description:
            "Built a reproducible nine-stage machine-learning pipeline for data ingestion, preprocessing, feature engineering, model training, evaluation, serialization, and inference using Python, TensorFlow, scikit-learn, and GPU-enabled SLURM clusters. Developed a multimodal PCOS prediction system combining a Gradient Boosting model across 41 clinical biomarkers with a fine-tuned MobileNetV2 computer-vision model, achieving 0.989 AUC-ROC, 96.3% accuracy, and 0.963 F1; co-authored the resulting research manuscript submitted for peer review at a conference.",
          color: "#4285F4",
        },
        {
          title: "Cybersecurity Researcher — Patriot Lab",
          company: "Dakota State University",
          company_url: "https://dsu.edu",
          logo_path: "dsu_logo.svg",
          duration: "January 2026 - May 2026",
          location: "Madison, SD",
          description:
            "Developed ASE-PQ, a semantic-aware post-quantum encryption framework for agricultural IoT using DWT-based multi-tier protection, ML-KEM-1024, and AES-256-GCM. Reduced average latency by 59%, encrypted payload size by 77%, and energy consumption by 59% versus DQRSE while maintaining 40.05 dB PSNR and 0.96 SSIM on Raspberry Pi 5; co-authored the resulting manuscript submitted to a peer-reviewed journal.",
          color: "#ee3c26",
        },
        {
          title: "Software Engineer",
          company: "Compliance Quest Nepal",
          logo_path: "CQ.png",
          duration: "August 2023 - June 2025",
          location: "Lalitpur, Nepal",
          description:
            "Re-architected a TypeScript integration service into a reusable JSON-configured architecture, increasing client adoption from 60% to 90% and reducing new-module onboarding from a multi-engineer process to ownership by one engineer. Led development of an LLM-assisted enterprise workflow using Salesforce Einstein, Apex services, and cross-module record orchestration, reducing user interaction steps by approximately 50%. Developed and integrated REST APIs, reusable backend services, and data-access components supporting enterprise workflows across multiple Salesforce modules. Built and tested production features using TypeScript, JavaScript, Apex, SOQL, SOSL, and Lightning Web Components, using unit testing and Jenkins CI/CD across three production release cycles.",
          color: "#0879bf",
        },
        {
          title: "Machine Learning Engineer",
          company: "Nepal Flying Labs",
          logo_path: "flyinglabs_logo.png",
          duration: "January 2021 - February 2023",
          location: "Kathmandu, Nepal",
          description:
            "Improved disaster-response model accuracy from 70% to 90% by integrating higher-quality spatial datasets, aligning geospatial features, and systematically tuning deep-learning hyperparameters. Built PyTorch and scikit-learn pipelines for geospatial preprocessing, feature engineering, transfer learning, model evaluation, and visualization supporting humanitarian-response workflows.",
          color: "#f39c12",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Rainbow  Volunteer Club Vlounteer",
          company: "Rainbow Volunteer Club",
          company_url: "https://www.facebook.com/rainbowFORlove/",
          logo_path: "rainbow.jpg",
          duration: "June 2019 - Present",
          location: "SrijanTol, Kathmandu",
          description:
            " Worked as a volunteer in this Club . The club is affilated to the original Club from China . We worked in Pandemic time by Providing foods to the poeple and orphans reciding in Kathamndau Valley ",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A selection of my recent work spanning machine learning, AI-assisted applications, and full-stack software engineering.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      title: "RNN vs LSTM vs Transformer",
      description:
        "Implemented and benchmarked RNN, LSTM, and Transformer architectures on next-word prediction over the WikiText-2 dataset, using an identical preprocessing and training pipeline for a fair comparison. Evaluated each model on perplexity, parameter count, training time, and generated-text quality, showing how self-attention outperforms recurrence on long-range dependencies. for more...",
      date: "Created on 2026-04-30",
      link: "https://github.com/darkamgel/RNN-vs-LSTM-vs-Transformer",
      tools: ["projects/pytorch.svg", "projects/python.png", "projects/jupyter.png"],
    },
    {
      title: "Public Records Research Platform",
      description:
        "An AI-assisted research platform for lawfully collecting, searching, and cross-matching public government records from scattered sources (PDF/CSV/JSON, with OCR fallback). Uses LangGraph and the OpenAI SDK to generate explainable, evidence-backed confidence scores for potential record matches, keeping a human reviewer in the loop for every decision rather than auto-merging records. for more...",
      date: "Created on 2026-08-03",
      link: "https://github.com/darkamgel/Records-Research-LAW",
      tools: ["projects/python.png", "projects/react.svg", "projects/postgresql.svg"],
    },
    {
      title: "Automated GIS Pipeline",
      description:
        "A config-driven, end-to-end GIS ETL pipeline that ingests raw GeoJSON, reprojects and loads it into PostGIS with spatial indexing, performs point-in-polygon spatial joins, and exports analysis-ready GeoPackage layers — built for reproducible spatial data engineering and research workflows. for more...",
      date: "Created on 2026-01-21",
      link: "https://github.com/darkamgel/Automated-GIS-Pipeline",
      tools: ["projects/python.png", "projects/postgresql.svg"],
    },
    {
      title: "JobMatch AI",
      description:
        "A zero-cost job-search portal where users upload a resume and get explainable, skill/title/experience-weighted match scores against searched job postings, with saved jobs, an application tracker, and sponsorship-detection from job descriptions. Runs on a fully free-tier stack (Netlify + Supabase). for more...",
      date: "Created on 2026-08-04",
      link: "https://github.com/darkamgel/Job-Search",
      tools: ["projects/react.svg", "projects/typescript.svg", "projects/supabase.svg"],
    },
    {
      title: "ExpenseFlow",
      description:
        "A responsive personal expense and budget manager with cross-device sync, backed by Supabase Postgres with Row-Level Security scoping every table to its owner. Includes budgets, recurring expenses, receipt storage, 8 report charts, and a full JSON/CSV backup-and-restore flow, with a Vitest suite covering the calculation and repository layers. for more...",
      date: "Created on 2026-08-02",
      link: "https://github.com/darkamgel/expenseflow",
      tools: ["projects/react.svg", "projects/typescript.svg", "projects/supabase.svg"],
    },
  ],
};

const publicationsHeader = {
  // title: "Publications",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  // avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "me.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Machine Learning, AI Systems, Security Research, and Full-Stack Development.",
  },
  blogSection: {
    // title: "Blogs",
    // subtitle:
    //   "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    // avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Madison, South Dakota, USA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Madison,+SD",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (605) 671-7121",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  projects,
  publicationsHeader,
  contactPageData,
};
